import { render, staticRenderFns } from "./AppNavbar.vue?vue&type=template&id=1fd76d11&scoped=true&"
import script from "./AppNavbar.vue?vue&type=script&lang=ts&"
export * from "./AppNavbar.vue?vue&type=script&lang=ts&"
import style0 from "./AppNavbar.vue?vue&type=style&index=0&id=1fd76d11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd76d11",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/backoffice-legado-frontend/backoffice-legado-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fd76d11')) {
      api.createRecord('1fd76d11', component.options)
    } else {
      api.reload('1fd76d11', component.options)
    }
    module.hot.accept("./AppNavbar.vue?vue&type=template&id=1fd76d11&scoped=true&", function () {
      api.rerender('1fd76d11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavbar.vue"
export default component.exports